import { Card, Container, Table, TableBody, TableContainer } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import AppLoadingAndErrorWrapper from 'src/components/common/AppLoadingAndErrorWrapper';
import FormProvider from 'src/components/hook-form/form-provider';
import Scrollbar from 'src/components/scrollbar';
import { TableHeadCustom, TablePaginationCustom, TableSkeleton } from 'src/components/table';
import AppTableToolbar from 'src/components/table/AppTableToolbar';
import AppPermissions from 'src/constants/app-permissions';
import { KNOWLEDGE_BASES_TABLE_HEAD } from 'src/constants/tables-heads';
import { Order_By } from 'src/graphql';
import KnowledgeBasesRow from './knowledge-bases-row';
import useKnowledgeBases from './use-knowledge-bases';

export type KnowledgeBasesFormType = {
  sortBy: string | undefined;
  sortDirection: Order_By.Asc | Order_By.Desc | undefined;
};

const KnowLedgeBases = () => {
  const {
    data,
    handleDeleteKnowledgeBase,
    handleSearch,
    isDeleting,
    isLoading,
    methods,
    query,
    setQuery,
    table,
    t,
  } = useKnowledgeBases();
  return (
    <Container>
      <Helmet>
        <title>{t('sidebar.knowledgeBases')}</title>
      </Helmet>
      <AppLoadingAndErrorWrapper isLoading={isDeleting} errorMessage={null}>
        <Card>
          <FormProvider methods={methods}>
            <AppTableToolbar
              handleSearch={handleSearch}
              search={query.search!}
              tableName=""
              buttons={[
                {
                  path: 'new',
                  permissionName: AppPermissions.KNOWLEDGE_BASES_CREATE,
                },
              ]}
            />
            <TableContainer>
              <Scrollbar>
                <Table>
                  <TableHeadCustom
                    setQuery={setQuery}
                    headLabel={KNOWLEDGE_BASES_TABLE_HEAD(t)}
                    methods={methods}
                  />
                  <TableBody>
                    {isLoading || isDeleting ? (
                      [...Array(table.rowsPerPage)].map((i, index) => (
                        <TableSkeleton key={index} sx={{ height: 80 }} />
                      ))
                    ) : (
                      <>
                        {data?.knowledge_bases?.map((row) => (
                          <KnowledgeBasesRow
                            key={row.knowledgeBaseId}
                            row={row}
                            deleteHandler={handleDeleteKnowledgeBase}
                          />
                        ))}
                      </>
                    )}
                  </TableBody>
                </Table>
              </Scrollbar>
            </TableContainer>
            {data && (
              <TablePaginationCustom
                count={+data.knowledge_bases_aggregate.aggregate?.count!}
                page={+table.page}
                rowsPerPage={table.rowsPerPage}
                onPageChange={table.onChangePage}
                onRowsPerPageChange={table.onChangeRowsPerPage}
              />
            )}
          </FormProvider>
        </Card>
      </AppLoadingAndErrorWrapper>
    </Container>
  );
};

export default KnowLedgeBases;
